// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"yQ","title":"zQ","nav":"AQ","flexCell":"BQ","facetLink":"CQ"};